import React from 'react';
import { HiOutlineSparkles } from "react-icons/hi2";

const AnnouncementCard = () => {
  return (
    <div className="relative overflow-hidden bg-slate-900 border-b border-white/5 shadow-2xl">
      {/* Subtle Animated Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 via-transparent to-purple-600/20 animate-pulse" />

      <div className="relative max-w-7xl mx-auto px-4 py-2.5 sm:py-2">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
          
          {/* Tag / Badge */}
          <div className="flex items-center gap-1.5">
            <span className="flex h-2 w-2 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
            </span>
            <span className="bg-blue-500/10 text-blue-400 text-[10px] font-black uppercase tracking-[0.2em] px-2 py-0.5 rounded-md border border-blue-500/20">
              Hiring Interns
            </span>
          </div>

          {/* Main Message */}
          <p className="text-white text-xs sm:text-sm font-bold tracking-tight text-center">
            Want to help build the future of <span className="text-blue-400">CampusIRA</span>? 
            <span className="hidden sm:inline opacity-60 ml-1">— We're looking for passionate developers to join our core team.</span>
          </p>

          {/* CTA Link */}
          <a 
            href="https://forms.gle/54tHUtoapEearpjt7" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-1 bg-white text-slate-900 px-4 py-1 rounded-full text-[11px] font-black uppercase tracking-wider hover:bg-blue-400 hover:text-white transition-all active:scale-95 shadow-lg shadow-white/5"
          >
            Apply Now
            <HiOutlineSparkles size={14} className="animate-bounce" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementCard;